import React from "react";
import { Badge } from "../../../../ui/components/Badge";
import { Tabs } from "../../../../ui/components/Tabs";
import { CashBankAccountEntity } from "../../domain";

interface CashBankAccountTabsProps {
  accounts: CashBankAccountEntity[];
  selectedAccountId: number | null;
  onSelectAccount: (accountId: number) => void;
  loading?: boolean;
}

export const CashBankAccountTabs: React.FC<CashBankAccountTabsProps> = ({
  accounts,
  selectedAccountId,
  onSelectAccount,
  loading = false,
}) => {
  if (loading) {
    return (
      <div className="flex w-full items-center gap-2 overflow-x-auto">
        {Array.from({ length: 3 }).map((_, index) => (
          <div
            key={index}
            className="h-9 w-36 flex-none animate-pulse rounded-md bg-neutral-100"
          />
        ))}
      </div>
    );
  }

  if (accounts.length === 0) {
    return null;
  }

  return (
    <Tabs>
      {accounts.map((account) => (
        <Tabs.Item
          key={account.id}
          active={selectedAccountId === account.id}
          onClick={() => onSelectAccount(account.id)}
        >
          {account.bank_name}
          {account.is_primary_account && (
            <Badge variant="success" className="ml-2">
              Primary
            </Badge>
          )}
        </Tabs.Item>
      ))}
    </Tabs>
  );
};
